module.exports = __webpack_public_path__ + "img/IMG_8673_L_WoodMatted.6e10927f.jpg";